import { defineComponent } from '../utils/alpine'
import gsap from 'gsap'

export const Header = defineComponent(() => ({
  init() {
    const tl = gsap.timeline({ paused: true })
    tl.fromTo(
      this.$el,
      { yPercent: -100 },
      {
        yPercent: 0,
        duration: 0.6,
        ease: 'power2.out',
        clearProps: 'transform',
      },
    )

    if ((window as any).preloaderComplete) {
      gsap.set(this.$el, { yPercent: 0, clearProps: 'transform' })
    } else {
      window.addEventListener('preloader:complete', () => {
        tl.play()
      })
    }
  },

  discard() {},
}))
